import { OnInit } from '@angular/core';
var CounselorsMenuComponent = /** @class */ (function () {
    function CounselorsMenuComponent() {
    }
    CounselorsMenuComponent.prototype.ngOnInit = function () {
    };
    return CounselorsMenuComponent;
}());
export { CounselorsMenuComponent };
